export const useStyles = (theme) => ({
  title: {
    fontSize: 24,
    padding: 20,
    display: "flex",
    justifyContent: "center",
    textDecoration: "none",
    color: "#181818",
    "&:hover": { textDecoration: "none" },
  },
  root: {
    color: "#0f1c50",
  },
  selectedStyle: {
    color: "#181818",
  },
  navStyle: {
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },
});
